import { Box, Typography, Paper } from "@mui/material";
import RatingStars from "./RatingStars";
import { useTranslation } from "react-i18next";
import RatingCategoryGrid from "@/components/ratings/RatingCategoryGrid";
import { formatDate } from "@/utils";
import { averageOverallRating } from "@/constants/ratings";
import type { Review } from "@/types";

interface PublicReviewer {
  id: string;
}

interface ReviewCardReview extends Omit<Review, "user"> {
  user?: PublicReviewer;
}

interface ReviewCardProps {
  review: ReviewCardReview;
  showCompany?: boolean;
}

export default function ReviewCard({ review, showCompany = false }: ReviewCardProps) {
  const { t } = useTranslation();
  const overall = averageOverallRating(review.ratings);

  return (
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          mb: 2,
        }}
      >
        <Box>
          {showCompany && review.company && (
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
              }}
            >
              {review.company.displayName}
            </Typography>
          )}
          <RatingStars value={overall} size="small" />
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {t("review.reviewerLabel")} &bull; {formatDate(review.createdAt)}
          </Typography>
        </Box>
      </Box>
      <RatingCategoryGrid ratings={review.ratings} gridSx={{ mb: 2 }} />
      {review.comment && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          {review.comment}
        </Typography>
      )}
    </Paper>
  );
}
